import { colors } from '../../tokens';
export default {
  wrapper: {
    position: 'absolute',
    left: '32px',
    bottom: 'calc(100% + 16px)',
    width: '248px',
    padding: '16px',
    border: "1px solid ".concat(colors.grey[200]),
    borderRadius: '4px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.1)',
    transform: 'translate(0, 15px)',
    opacity: 0,
    zIndex: -1,
    transition: 'opacity 200ms, transform 200ms'
  },
  arrow: {
    position: 'absolute',
    top: 'calc(100% - 6px)',
    display: 'block',
    width: '13px',
    height: '13px',
    transform: 'rotate(45deg)',
    borderRadius: '2px',
    background: '#fff',
    borderBottom: "1px solid ".concat(colors.grey[200]),
    borderRight: "1px solid ".concat(colors.grey[200]),
    left: '16px'
  },
  text: {
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.dark
  },
  icon: {
    position: 'absolute',
    left: '16px',
    top: '50%',
    transform: 'translate(0, -50%)',
    width: '16px'
  }
};